import React from "react";
import Routes from "./Routes";
import MediaBackground from "./components/ui/MediaBackground";

function App() {
  return (
    <>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-background focus:text-accent focus:top-0 focus:left-0">
        Skip to main content
      </a>
      <MediaBackground />
      <Routes />
    </>
  );
}

export default App;
